export const parseBusinessFromDBToValidFormat = (business) => {
  const valid = [];
  const issues = [];
  if (business.Duplicates) {
    let duplicates = JSON.parse(business.Duplicates);
    if (duplicates.length > 0) {
      issues.push({
        header: `${duplicates.length} doublons potentiels détectés`,
        content:
          "Un doublon signifit qu'une fiche GMB ayant des informations similaires aux votres a été détecté. Cela peut hurter gravement votre e-réputation. Rendez-vous dans la section doublon pour plus de détails.",
      });
    }
  }
  if (business.IsCompanyClaimed) {
    valid.push({
      header: "Établissement revendiqué",
      content:
        "Revendiquez votre fiche Google my Business est la première étape pour votre SEO local. Si vous n'avez pas revendiqué votre GMB, vous ne pourrez pas optimiser votre fiche. Lorsque vous revendiquez votre fiche GMB, vous pouvez modifier vos informations. Si votre fiche n'est pas créé vous devez suivre la procédure pour valider votre établissement.",
    });
  } else {
    issues.push({
      header: "Établissement non revendiqué",
      content:
        "Revendiquez votre fiche Google my Business est la première étape pour votre SEO local. Si vous n'avez pas revendiqué votre GMB, vous ne pourrez pas optimiser votre fiche. Lorsque vous revendiquez votre fiche GMB, vous pouvez modifier vos informations. Si votre fiche n'est pas créé vous devez suivre la procédure pour valider votre établissement.",
    });
  }
  if (business.Address) {
    valid.push({
      header: "Adresse renseignée",
      content:
        "Mettre une adresse si vous avez un établissement physique. Google favorise les fiches avec adresse car cela montre que vous êtes un vrai établissement et non un spam.",
    });
  } else {
    issues.push({
      header: "Adresse non renseignée",
      content:
        "Mettre une adresse si vous avez un établissement physique. Google favorise les fiches avec adresse car cela montre que vous êtes un vrai établissement et non un spam.",
    });
  }
  if (business.Website) {
    valid.push({
      header: "Site web renseigné",
      content:
        "Vous devez mettre la bonne adresse de votre site web. Ne pas utiliser votre page facebook ou linkedin dans cette section.",
    });
  } else {
    issues.push({
      header: "Site web non renseigné",
      content:
        "Vous devez mettre la bonne adresse de votre site web. Ne pas utiliser votre page facebook ou linkedin dans cette section.",
    });
  }
  if (business.Phone) {
    valid.push({
      header: "Téléphone renseigné",
      content:
        "Mettez votre numéro de téléphone principal et évitez qu'il soit changé.",
    });
  } else {
    issues.push({
      header: "Téléphone non renseigné",
      content:
        "Mettez votre numéro de téléphone principal et évitez qu'il soit changé.",
    });
  }
  if (business.HasReviews) {
    valid.push({
      header: "Objectif premier avis",
      content:
        "Vous avez obtenu votre premier avis, c'est super ! Ne vous arrêtez pas en si bon chemin ! Vous devez améliorer votre e-réputation et votre seo local grâce aux avis. Avoir des avis vous permet d'avoir plus de visibilité sur Google. Les gens prennent de plus en plus une décision d'achat grâce aux avis. Une étude montre qu'avoir plus d'avis sur Google My Business peut augmenter vos conversions de 20%.",
    });
  } else {
    issues.push({
      header: "Objectif premier avis",
      content:
        "Vous n'avez aucun avis sur votre fiche GMB. Vous devez améliorer votre e-réputation et votre seo local grâce aux avis. Avoir des avis vous permet d'avoir plus de visibilité sur Google. Les gens prennent de plus en plus une décision d'achat grâce aux avis. Une étude montre qu'avoir plus d'avis sur Google My Business peut augmenter vos conversions de 20%.",
    });
  }
  if (business.Nbreviews > 20) {
    valid.push({
      header: "Vous avez plus de 20 avis",
      content:
        "Vous avez déjà plus de 20 avis, ce qui est un bon point. Cependant, nous vous conseillons de demander à vos clients plus d'avis ! Pour se faire, retrouvez dans la catégorie Avis quelques astuces.",
    });
  } else {
    issues.push({
      header: "Vous n'avez pas assez d'avis",
      content:
        "Vous avez très peu d'avis, il va falloir corriger cela. Nous vous conseillons de demander à vos clients plus d'avis !",
    });
  }
  if (business.IsBusinessHoursFilled) {
    valid.push({
      header: "Horaires renseignés",
      content:
        "Vos horaires d'ouvertures et fermetures doivent être visible pour informer vos clients de vos disponibilités. Ne vous trompez pas d'heure cela pourrait frustrer certains visiteurs.",
    });
  } else {
    issues.push({
      header: "Horaires non renseignés",
      content:
        "Vos horaires d'ouvertures et fermetures doivent être visible pour informer vos clients de vos disponibilités. Ne vous trompez pas d'heure cela pourrait frustrer certains visiteurs.",
    });
  }
  if (business.IsQandAFilled) {
    valid.push({
      header: "FAQ renseignée",
      content:
        "La FAQ permet aux internautes de poser des questions directement à l'entreprise. Elle est affichée au public donc il faut faire attention à ce que vos clients mettent dessus et bien y répondre. L'entreprise peut aussi créer ses propres questions et y répondre. La FAQ vous évite d'avoir des demandes inutiles par téléphone et améliore votre taux de clics.",
    });
  } else {
    issues.push({
      header: "FAQ non renseignée",
      content:
        "La FAQ permet aux internautes de poser des questions directement à l'entreprise. Elle est affichée au public donc il faut faire attention à ce que vos clients mettent dessus et bien y répondre. L'entreprise peut aussi créer ses propres questions et y répondre. La FAQ vous évite d'avoir des demandes inutiles par téléphone et améliore votre taux de clics.",
    });
  }
  if (business.MerchandDescription) {
    valid.push({
      header: "Description renseignée",
      content:
        "Ecrivez une petite description pour votre entreprise avec votre mot clé principal et votre zone géographique. N'hésitez pas à mettre en avant ce qui vous distingue des autres concurrents. Ne pas sur-optimiser votre texte, c'est à dire ne pas répéter plusieurs fois vos mots clés.",
    });
  } else {
    issues.push({
      header: "Description non renseignée",
      content:
        "Ecrivez une petite description pour votre entreprise avec votre mot clé principal et votre zone géographique. N'hésitez pas à mettre en avant ce qui vous distingue des autres concurrents. Ne pas sur-optimiser votre texte, c'est à dire ne pas répéter plusieurs fois vos mots clés.",
    });
  }
  if (business.HasSocialProfiles) {
    valid.push({
      header: "Réseaux sociaux liés",
      content:
        "Vos profils de réseaux sociaux sont liés à votre fiche Google Business Profile. Cela renforce la crédibilité de votre établissement et permet aux clients de vous retrouver facilement sur les différentes plateformes.",
    });
  } else {
    issues.push({
      header: "Aucun réseau social lié",
      content:
        "Liez vos profils de réseaux sociaux (Facebook, Instagram, LinkedIn, etc.) à votre fiche Google Business Profile. Cela renforce votre présence en ligne et permet aux clients de vous retrouver plus facilement.",
    });
  }
  if (business.HasPosts) {
    valid.push({
      header: "Vous avez des Google Posts",
      content:
        "Google posts vous permet d'avoir plus de visibilité et informer vos clients sur votre actualité. Ils vous donnent une meilleure visibilité et donne la possibilité d'attirer plus de clients dans votre établissement. Les Google posts sont visible sur les résultats de recherches sous votre fiche et améliore votre taux de clics. Continuez à publier !",
    });
  } else {
    issues.push({
      header: "Vous n'avez pas de Google Posts récents",
      content:
        "Google posts vous permet d'avoir plus de visibilité et informer vos clients sur votre actualité. Ils vous donnent une meilleure visibilité et donne la possibilité d'attirer plus de clients dans votre établissement. Les Google posts sont visible sur les résultats de recherches sous votre fiche et améliore votre taux de clics.",
    });
  }
  if (business.Rating >= 4) {
    valid.push({
      header: "Votre note moyenne est bonne",
      content:
        "Toujours avoir une note supérieure ou égale à 4 / 5. Des études montrent que avoir une bonne note générale améliorer votre taux de clics. Un établissement avec 5 étoiles recevra plus de clics qu'un établissement avec 2 étoiles.",
    });
  } else {
    issues.push({
      header: "Votre note moyenne n'est pas bonne",
      content:
        "Toujours avoir une note supérieure ou égale à 4 / 5. Des études montrent que avoir une bonne note générale améliorer votre taux de clics. Un établissement avec 5 étoiles recevra plus de clics qu'un établissement avec 2 étoiles.",
    });
  }
  if (business.HasProducts) {
    valid.push({
      header: "Produits renseignés",
      content:
        "Certains établissements peuvent montrer leurs produits ou services avec une description et les prix sur les résultats de recherches. Ils seront visibles sous la fiche de l'établissement. Lorsque vous avez renseigné vos produits/services, vous améliorez votre taux de clics et les conversions sur votre fiche.",
    });
  } else {
    issues.push({
      header: "Aucun produit renseigné",
      content:
        "Certains établissements peuvent montrer leurs produits ou services avec une description et les prix sur les résultats de recherches. Ils seront visibles sous la fiche de l'établissement. Lorsque vous avez renseigné vos produits/services, vous améliorez votre taux de clics et les conversions sur votre fiche.",
    });
  }

  const parsedCB = {
    business,
    valid,
    issues,
  };
  return parsedCB;
};
